export const ENVIRONMENT = {
  PRODUCTION: 'Production',
  STAGE: 'Staging'
}
